import React, { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { actionCreators } from '@/store/phoneNumber'
import { Button } from '@/components/button'
import { useLocalization } from '@/hooks/localization'
import { dialogTypes } from '@/dialogs'
import LoadingIndicator from '@/components/LoadingIndicator'

const PhoneNumber = ({ openDialog, updatePhoneNumber, getPhoneNumber, phoneNumber }) => {
  const { localize } = useLocalization()
  const handleClick = useCallback(() => openDialog({
    dialogType: dialogTypes.editPhoneNumber,
    onAction: (input) => updatePhoneNumber(input),
    phoneNumber: phoneNumber.phone
  }), [openDialog, phoneNumber.phone, updatePhoneNumber])
  useEffect(() => getPhoneNumber(), [getPhoneNumber])
  const isLoading = phoneNumber.fetching || phoneNumber.updating
  return (
    <React.Fragment>
      {isLoading && <LoadingIndicator inline />}
      {!isLoading && <React.Fragment>
        <span className='phone-number'>{phoneNumber.phone}</span>
        <div className='edit-phone-button'>
          <Button onClick={handleClick} title={localize('Common.Edit')}>...</Button>
        </div>
      </React.Fragment>}
    </React.Fragment>
  )
}

const mapStateToProps = (state, ownProps) => ({
  phoneNumber: state.phoneNumber,
  ...ownProps
})

const mapDispatchToProps = {
  openDialog: dialogActions.openDialog,
  getPhoneNumber: actionCreators.getPhoneNumber,
  updatePhoneNumber: actionCreators.updatePhoneNumber
}

export default connect(mapStateToProps, mapDispatchToProps)(PhoneNumber)



// WEBPACK FOOTER //
// ./src/components/userProfile/phoneNumber.js